import { useMemo, useState } from "react";
import { useIntl } from "react-intl";
import { useSharedTable } from "../../../shared/table";
import type {
    FilaInventario,
    SeleccionInventario,
    VisualizacionInventario,
} from "../types/catalogoInventario.types";
import {
    construirColumnasInventario,
    type AccionesInventario,
} from "../components/CatalogoInventarioColumnas";

export const useTablaInventario = (
    filas: FilaInventario[],
    acciones: AccionesInventario,
    seleccion: SeleccionInventario
) => {
    const intl = useIntl();
    const [visualizacion, setVisualizacion] = useState<VisualizacionInventario>("cuadricula");

    const textos = useMemo(
        () => ({
            clave: intl.formatMessage({ id: "input_clave", defaultMessage: "Clave" }),
            nombre: intl.formatMessage({ id: "input_nombre", defaultMessage: "Nombre" }),
            precio: intl.formatMessage({ id: "input_precio", defaultMessage: "Precio" }),
            unidadMedida: intl.formatMessage({ id: "select_unidad_medida", defaultMessage: "Unidad" }),
            categoria: intl.formatMessage({ id: "select_categoria", defaultMessage: "Categoría" }),
            cantidad: intl.formatMessage({ id: "input_cantidad", defaultMessage: "Cantidad" }),
            maximos: intl.formatMessage({ id: "input_maximos", defaultMessage: "Máximos" }),
            minimos: intl.formatMessage({ id: "input_minimos", defaultMessage: "Mínimos" }),
            puntoReorden: intl.formatMessage({ id: "input_punto_reorden", defaultMessage: "Punto de reorden" }),
            ubicacion: intl.formatMessage({ id: "select_ubicacion", defaultMessage: "Ubicación" }),
            almacen: intl.formatMessage({ id: "select_almacen", defaultMessage: "Almacén" }),
            fecha: intl.formatMessage({ id: "general_fecha_creacion", defaultMessage: "Fecha de creación" }),
            estatus: intl.formatMessage({ id: "general_estatus", defaultMessage: "Estatus" }),
            acciones: intl.formatMessage({ id: "general_acciones", defaultMessage: "Acciones" }),
            ver: intl.formatMessage({ id: "general_vista_previa", defaultMessage: "Vista previa" }),
            editar: intl.formatMessage({ id: "general_editar", defaultMessage: "Editar" }),
            activar: intl.formatMessage({ id: "general_activar", defaultMessage: "Activar" }),
            desactivar: intl.formatMessage({ id: "general_desactivar", defaultMessage: "Desactivar" }),
            yaTieneQr: intl.formatMessage({ id: "general_ya_tiene_qr", defaultMessage: "Ya tiene QR" }),
        }),
        [intl]
    );

    const columnas = useMemo(
        () => construirColumnasInventario(textos, acciones, seleccion),
        [textos, acciones, seleccion]
    );

    const control = useSharedTable<FilaInventario>({
        columnas,
        datos: filas,
        obtenerIdFila: (fila) => String(fila.id),
    });

    return { control, textos, visualizacion, cambiarVisualizacion: setVisualizacion };
};
